import React from 'react';
import _ from 'lodash';

class Week extends React.Component {
    renderDays() {
        let date = this.props.date;
        const days = [];
        const month = this.props.month;
        const week = date.week();
        days.push(
            <span key={"week-" + week} className={"week-nr"}>{week}</span>
        );
        for (var i = 0; i < 7; i++) {
            var day = {
                name: date.format('dd').substring(0, 1),
				number: date.date(),
				isCurrentMonth: date.month() === month.month(),
                isPrevMonth: date.month() < month.month(),
                isNextMonth: date.month() > month.month(),
				isToday: date.isSame(new Date(), 'day'),
				date: date,
                isGrayShift: _.includes(this.props.coloredDates['gray'], date.format('DD.MM.YYYY')),
                isGreenShift: _.includes(this.props.coloredDates['green'], date.format('DD.MM.YYYY')),
                isOrangeShift: _.includes(this.props.coloredDates['orange'], date.format('DD.MM.YYYY'))
            };

            var colorShift = '';

            if(day.isOrangeShift) {
                colorShift = ' dot dot-orange';
            } else if(day.isGreenShift) {
                colorShift = ' dot dot-green';
            } else if(day.isGrayShift) {
                colorShift = ' dot dot-gray';
            }

            const onClick = !day.isGreenShift && !day.isGrayShift && !day.isOrangeShift ? e => e.preventDefault() : this.props.select.bind(null, day)
            days.push(
                <span key={day.date.toString()} onClick={onClick} className={"day"
                + colorShift
                + (day.isToday ? ' today' : '')
                + (day.isCurrentMonth ? '' : ' different-month')
                + (day.date.isSame(this.props.selected) ? ' selected' : '')
                + (!day.isGreenShift && !day.isGrayShift && !day.isOrangeShift ? ' disabled' : '')}>
                    {day.number}
                </span>
            );
            date = date.clone();
            date.add(1, "d");
        }

        return days;
    }

    render() {
        return (
            <div className="calendar-week">
                {this.renderDays()}
    		</div>
        );
    }
}
export default Week;



/** WEBPACK FOOTER **
 ** ./app/src/components/Calendar/Week.js
 **/